import Support from '@mui/icons-material/ContactSupportOutlined';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import { useState } from 'react';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';

import type { FAQProps } from '../../sections/UPS/FAQ/constants';

import AccordionFAQ from '../../sections/UPS/FAQ/Accordion/Accordion';
import { FAQS } from '../../sections/UPS/FAQ/constants';

const InternationalFAQ = () => {
  usePageTitle('Internacional - Preguntas frecuentes');

  const [expanded, setExpanded] = useState<number | false>(false);

  const openClosePanel = (panel: number) => (_: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <Container maxWidth="xxl" sx={{ paddingBottom: '3rem' }}>
      <SectionTitle title="Preguntas frecuentes" mt={5}>
        <Support fontSize="large" />
      </SectionTitle>
      <DividerStyled />
      {FAQS?.map((item: FAQProps, index: number) => (
        <AccordionFAQ
          key={index}
          question={item.question}
          answer={item.answer}
          id={item.id}
          openClose={openClosePanel}
          expanded={expanded}
        />
      ))}
    </Container>
  );
};

export default InternationalFAQ;

export const DividerStyled = styled(Divider)(() => ({
  width: '100px',
  margin: '2rem auto',
  borderWidth: '2px',
  backgroundColor: '#85C440',
}));
